import { render, staticRenderFns } from "./FileNamingRulesPage.vue?vue&type=template&id=4a432018&"
import script from "./FileNamingRulesPage.vue?vue&type=script&lang=ts&"
export * from "./FileNamingRulesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports